/* rpd-hover — product tiles whose second media is a video play it on hover (desktop pointers only). */
(function(){
  if(!window.matchMedia('(hover:hover)').matches) return;
  document.addEventListener('mouseover',function(e){
    var tile=e.target.closest&&e.target.closest('.rp-tile'); if(!tile||tile.classList.contains('is-playing')) return;
    var v=tile.querySelector('video.rp-tile__vid'); if(!v) return;
    tile.classList.add('is-playing'); v.muted=true; var p=v.play(); if(p&&p.catch) p.catch(function(){});
  });
  document.addEventListener('mouseout',function(e){
    var tile=e.target.closest&&e.target.closest('.rp-tile'); if(!tile) return;
    if(e.relatedTarget&&tile.contains(e.relatedTarget)) return;
    var v=tile.querySelector('video.rp-tile__vid'); if(!v) return;
    tile.classList.remove('is-playing'); v.pause(); try{ v.currentTime=0; }catch(err){}
  });
})();
